import { useMutation } from '@tanstack/react-query';

import { MutationFunction, Order, useRequest } from '@frontend/api';
import { keysToSnakeCaseDeep } from '@frontend/utils';

export const transformFacilitateData = (data: FacilitateOrderData) => {
  const formData = new FormData();
  if (data.poFile) {
    formData.append('po_file', data.poFile);
  }
  const snakeCasedData = keysToSnakeCaseDeep(data);
  for (const key in snakeCasedData)
    snakeCasedData[key] !== null &&
      snakeCasedData[key] !== undefined &&
      formData.append(key, snakeCasedData[key]);
  formData.append('data', JSON.stringify(snakeCasedData));
  return formData;
};

export type FacilitateOrderData = {
  quoteNumber: number;
  revisionNumber?: string | number;
  selectedOptionsList: {
    quoteItemId: number;
    expediteId: number | null;
    quantityId: number;
    addOnCellIds: number[];
  }[];
  shippingInfo: {
    type: string;
    method: string;
    grouping: string;
    customerAccount: string;
    customerCarrier: string;
  } | null;
  billingInfo: {
    type: string;
    method: string;
    grouping: string;
    customerAccount: string;
    customerCarrier: string;
  } | null;
  paymentMethod: string;
  stripeToken?: string;
  card?: string;
  poFile?: File;
  poNumber?: string;
  pointOfContact?: string;
  confirmationEmail?: string;
  shippingOption?: {
    type: string;
    method?: string;
    grouping?: string;
    customerAccount?: string;
    customerCarrier?: string;
  };
  shippingRateToken?: string;
  withConfirmation?: boolean;
};

export const useFacilitateOrder: MutationFunction<
  Order,
  {
    quoteId: number;
    data: FacilitateOrderData;
  }
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ quoteId, data }) => {
      const formData = transformFacilitateData(data);
      return request(`/orders/facilitate/quote/${quoteId}`, {
        init: { method: 'POST', body: formData },
        query,
      });
    },
    ...queryOptions,
  });
};
